var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidecart" }, [
    _c(
      "div",
      { staticClass: "sidecart__container" },
      [
        _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
          _vm.totalItems > 0
            ? _c(
                "div",
                { key: "content", staticClass: "sidecart__contents-wrapper" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "sidecart__contents padded",
                      attrs: { id: "sidecartContents" }
                    },
                    _vm._l(_vm.itemsNotInKits.slice(0, 2), function(
                      item,
                      index
                    ) {
                      return _c("modal-line-item", {
                        key: item.id,
                        attrs: { item: item }
                      })
                    }),
                    1
                  ),
                  _vm.remainingProductCount
                    ? _c(
                        "v-link",
                        {
                          staticClass: "sidecart__overflow-link hover-opacity",
                          attrs: { secondary: true },
                          on: {
                            click: function() {
                              return _vm.$emit("open-full")
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.remainingProductCount + " More Products")
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "sidecart__footer padded",
                      class: _vm.enableFooterDropshadow
                        ? "footer-dropshadow-enabled"
                        : ""
                    },
                    [
                      _c("table", { staticClass: "sidecart__table" }, [
                        _c("tbody", { staticClass: "sidecart__table-body" }, [
                          _c("tr", { staticClass: "sidecart__table-row" }, [
                            _c("td", { staticClass: "text-left" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "sidecart__view-cart text-left body-md hover-opacity",
                                  on: {
                                    click: function() {
                                      return _vm.$emit("open-full")
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "View Cart (" + _vm._s(_vm.totalItems) + ")"
                                  )
                                ]
                              )
                            ]),
                            _c(
                              "td",
                              { staticClass: "sidecart__table-data-price" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "body-md strong-medium" },
                                  [_vm._v("Subtotal: ")]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "body-md strong-medium" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("moneyWithoutDecimals")(
                                          _vm.totalPrice
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _c("v-button", {
                        staticClass: "sidecart__checkout-cta",
                        class: [_vm.colors.cta],
                        attrs: {
                          full: true,
                          type: "submit",
                          name: "checkout",
                          value: "Checkout",
                          label: "CHECKOUT"
                        },
                        on: { click: _vm.goToCheckout }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }